import { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router'
import './App.css'
import { QRCodeSVG } from 'qrcode.react'
import { startIdentityVerification } from './client-api'

function IdvFlow() {
  const { ref } = useParams()
  const [element, setElement] = useState(<div>Starting verification...</div>)
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) return
    hasRun.current = true
    const run = async () => {
      const task = await startIdentityVerification(`/oauth2/idv/${ref}`)
      setElement(
        <>
          <h3>Verify your identity with Ollet</h3>
          <p>
            Scan this QR code to continue on your device. 
          </p>
          <div>
          <p>
            If this is your first time using Ollet, you'll need your passport.
          </p>
          <p>
            Your ID and biometrics never leave your device.
          </p>
          </div>
          
          <QRCodeSVG value={task.olletUrlString} size={256} level="M" />
        </>,
      )
      await task.verificationStarted()
      setElement(<div>Please complete verification in Ollet</div>)
      const result = await task.verificationResult()
      const { redirect } = await result.json()
      setElement(<div>Redirecting back to Okta</div>)
      console.log("setElement(<div>Redirecting back to Okta</div>)")
      window.location.assign(redirect)
      console.log("window.location.assign(redirect)")
    }
    run().catch((e) => {
      console.log("error" + String(e))
      setElement(<div>Verification failed: {String(e)}</div>)
    })
  }, [ref])

  return <div className="card">{element}</div>
}

export default IdvFlow
